import { DELETE, GET, PATCH, POST } from "../../axios/apiService";

export const getPlans = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/plans`;
  return GET(url, options);
};

export const checkoutPlan = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/checkout/session`;
  return POST(url, data, options);
};

export const getSubscriptions = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/billing/overview`;
  return GET(url, options);
};

export const getBillingHistory = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/billing/history${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getCreditsOverview = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/credits/overview`;
  return GET(url, options);
};

export const getUsageByProduct = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/analytics/products`;
  return GET(url, options);
};

export const getUsageChart = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/analytics/chart${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getUsageBillingLog = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/analytics/credits${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const managePaymentMethod = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/billing/manage-payment-methods`;
  return POST(url, data, options);
};

export const cancelSubscripton = async ({ id, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/subscriptions/${id}`;
  return DELETE(url, options);
};

export const revokeCancellation = async ({ id, data = {}, options }) => {
  const url = `${process.env.REACT_APP_API_LEDGER_BASE_URL}/api/v1/workspace/subscriptions/${id}/revoke-cancellation`;
  return POST(url, data, options);
};
